import type { ICounterpartApi } from 'apiConnector/counterpart/counterpart';
import { counterpartApiConnector } from 'apiConnector/counterpart/counterpart';
import { connect } from 'react-redux';
import type { ThunkDispatch } from 'state/state.common';
import { userPreferencesRequested } from 'state/userPreferences/userPreferences.action';
import { httpClient } from 'utils/http/httpClient';

const counterpartApi = counterpartApiConnector(httpClient);

interface StateProps {
  counterpartApi: ICounterpartApi;
}

interface DispatchProps {
  onOpened: () => void;
}

export type UserPreferencesButtonProps = StateProps & DispatchProps;

/** @todo Maybe encapsulate this in an epic */
const mapStateToProps = (): StateProps => {
  return {
    counterpartApi,
  };
};

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
  return {
    onOpened: () => {
      dispatch(userPreferencesRequested());
    },
  };
}

export const connectUserPreferencesButton = connect(mapStateToProps, mapDispatchToProps);
